import { AutoComplete, Input, Select, Radio } from "antd";
import { set } from "date-fns";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ManageDataInPrescription,
  updateManagePrescriptionSubmissionData,
} from "../../../../../../actions/ManagePrescriptionAction";
import { TOGGLE_SELECT_SYMPTOM_PRESCRIPTION } from "../../../../../../actions/type";
import { AssetStore } from "../../../../../../assets/AssetsStore";
import {
  BlackAdd,
  BlueAdd,
  ClockSmall,
} from "../../../../../../assets/Logos/Icons";
import { saveSymptom } from "../../../../../../reducers/symptom.api";
import Searchbox from "../../../../../ManagePrescriptionComponents/SearchBox/Searchbox";
import {
  PrescriprionContext,
  prescriptionEnums,
} from "../../../../PrintPrescription";
import AddDataModal from "../../../Modals/AddDataModal/AddDataModal";
import styles from "./index.module.scss";
import Textarea from "react-expanding-textarea";
import { getDepartmentList } from "../../../../../../reducers/symptom.api";

function RecentSymptoms({
  data,
  haveNote,
  name,
  addTitle,
  callFunction,
  detailedData,
  noteValue,
  onChangeNote,
  mode = "multi",
}) {
  const dispatch = useDispatch();
  const [submissionData, setSubmissionData] = useState([]);
  const [submissionSymptoms, setSubmissionSymptoms] = useState([]);
  const initialSymptoms = data;
  const [detailKeys, setDetailKeys] = useState([]);
  const [currentDetailData, setCurrentDetailData] = useState({});

  const [selectedSymptomId, setSelectedSymptomId] = useState(null);

  const [, forceUpdate] = useState({});

  const { wholeData, handleWholeData } = useContext(PrescriprionContext);

  const textareaRef = useRef(null);

  const [departmentList, setDepartmentList] = useState([]);

  useEffect(() => {
    // Fetch department list
    /*getDepartmentList(wholeData.doctorCode, (res) => {
      setDepartmentList(res);
    });*/

    // If detailedData is available, handle it
    if (detailedData && detailedData.length > 0) {
      handleDetailedData();
      handleSymptomData();
    }
  }, [wholeData.doctorCode, detailedData]);

  const isAnArray = (data) => {
    return Array.isArray(data);
  };

  const isMultiSelect = useCallback(
    (item) => {
      const multiSelectItems = ["severity", "since", "more", "grade"];
      return mode === "multi" && multiSelectItems.includes(item);
    },
    [mode]
  );

  //debugger;

  const handleDetailedData = () => {
    if (selectedSymptomId && detailedData) {
      const selectedSymptom = detailedData.find(
        (item) => item?.symptomName === selectedSymptomId
      );

      if (selectedSymptom) {
        const symptomDetail = selectedSymptom.symptomDetail;

        if (Array.isArray(symptomDetail)) {
          // New format
          setDetailKeys(symptomDetail.map((item) => item.name));
          setCurrentDetailData(symptomDetail);
        } else if (typeof symptomDetail === "object") {
          // Old format
          const keys = Object.keys(symptomDetail);
          const orderedKeys = [
            "severity",
            "frequency",
            "more",
            "since",
            "note",
            "grade",
          ].filter((key) => keys.includes(key));
          setDetailKeys(orderedKeys);
          setCurrentDetailData(
            orderedKeys.map((key) => ({
              name: key,
              selection: isMultiSelect(key) ? "Multi Select" : "Single Select",
              options: symptomDetail[key],
            }))
          );
        }
      }
    }
  };

  const handleSymptomData = () => {
    const dataIndex = submissionData.findIndex(
      (item) => item.name === selectedSymptomId
    );
    setSubmissionSymptoms(submissionData[dataIndex]?.detailData ?? {});
  };

  useEffect(() => {
    if (selectedSymptomId && detailedData && detailedData.length > 0) {
      handleDetailedData();
      handleSymptomData();
    }
  }, [selectedSymptomId, detailedData]);

  const [isOpen, setOpne] = useState(false);
  const [isAddOpen, setAddOpen] = useState(false);
  const [selected, setSelected] = useState(false);
  const [searchValues, setSearchValues] = useState([]);
  const ref = useRef(null);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [textareaHeight, setTextareaHeight] = useState("auto");

  useEffect(() => {
    const textarea = document.getElementById("noteTextarea");
    if (textarea) {
      setTextareaHeight(`${textarea.scrollHeight}px`);
    }
  }, [noteValue]);

  useEffect(() => {
    setSearchValues(createSearchOptions(initialSymptoms));
  }, [initialSymptoms]);

  const isSelected = (params) => {
    let { name } = params;
    let data = submissionData;
    if (data && data.length > 0) {
      let res = data.filter((e) => e.name === name);
      return res && res.length > 0;
    }
  };

  const handleItemClick = (name) => {
    setSelectedSymptomId(name.name);
    if (name.name === "Routine visit") {
      setSelected(() => name);
      setSubmissionData([...submissionData, name]);
      // Don't have to open the parameter box for Routine visit
    } else {
      if (isSelected(name)) {
        if (isOpen) {
          setOpne(false);
        } else {
          setSelected(() => name);
          setOpne(true);
        }
      } else {
        setSubmissionData([...submissionData, name]);
        setSelected(() => name);
        setOpne(true);
      }
    }
  };

  const handleItemClickSelected = (name) => {
    setSelectedSymptomId(name.name);
    if (isSelected(name) && selected === name) {
      if (isOpen) {
        setOpne(false);
      } else {
        setSelected(() => name);
        setOpne(true);
      }
    } else {
      setSelected(() => name);
      setOpne(true);
    }
  };

  // const detailData = [
  //   {
  //     name: "Severity",
  //     selection: "Single Select",
  //     options: ["Mild", "Moderate", "Severe"],
  //     required: "true",
  //     restriction: "Max 1",

  //   },
  //   {
  //     name: "Since",
  //      selection: "Single Select",
  //     options: ["1D", "2D", "3D", "4D", "Week"],
  //     required: "true",
  //     restriction: "Max 1",

  //   },
  //   {
  //     name: "Note",
  //     selection: "Text Box",
  //     restriction: "Alphanumeric",
  //     required: "false"
  // },
  // ];
  const createDetailItem = (
    name,
    selection,
    options,
    required,
    restriction
  ) => ({
    name,
    selection,
    options,
    required,
    restriction,
  });

  const detailData = [
    {
      name: "Severity",
      selection: "Single Select",
      options: ["Mild", "Moderate", "Severe"],
      required: "true",
      restriction: "Max 1",
    },
    {
      name: "Since",
      selection: "Single Select",
      options: ["1D", "2D", "3D", "4D", "Week"],
      required: "true",
      restriction: "Max 1",
    },
    {
      name: "Note",
      selection: "Text Box",
      restriction: "Alphanumeric",
      required: "false",
    },
  ];

  const keyValue = detailData.map((item) => item.name);

  const handleAddData = async (name) => {
    const departmentId = departmentList[0]?.departmentId;
    console.debug("departmentId", departmentId);
    console.log("abcd", wholeData);
    await saveSymptom(
      wholeData?.doctorCode,
      departmentId,
      name?.name,
      detailData
    );

    callFunction();
    handleItemClick(name);
    setSelectedSymptomId(name.name);
    setDetailKeys(keyValue);
    setCurrentDetailData(detailData);

    dispatch(
      ManageDataInPrescription({
        context: "Add",
        item: "symptom",
        payload: name,
        existing: data,
      })
    );
    dispatch(
      ManageDataInPrescription({
        context: "Toggle",
        item: "symptom",
        payload: name,
        existing: submissionData?.symptoms,
      })
    );
    setSelected(() => name);
    setOpne(true);
  };

  // const handleAddData = async (name) => {
  //   const departmentId = departmentList[0]?.departmentId;

  //   await saveSymptom(
  //     name.name,
  //     departmentId,
  //     detailData,
  //     callFunction()

  //   );
  //   setSelectedLabFindingsId(name.name);
  //   setOpne(true);
  //   handleSelectData(name);
  //    setDetailKeys(keyValue);
  //    setCurrentDetailData(detailData);

  //   dispatch(
  //     ManageDataInPrescription({
  //       context: "Add",
  //       item: "examination",
  //       payload: name,
  //       existing: initialData,
  //     })
  //   );
  //   dispatch(
  //     ManageDataInPrescription({
  //       context: "Toggle",
  //       item: "examination",
  //       payload: name,
  //       existing: submissionData?.examinations,
  //     })
  //   );
  //   setSelected(() => name);
  // };

  const isSubSelected = useCallback(
    (key, value) => {
      return submissionSymptoms[key]?.includes(value) || false;
    },
    [submissionSymptoms]
  );

  const getSubValue = (key) => {
    return submissionSymptoms[key];
  };

  const handleDetailDataSelection = () => {
    let temp = [...submissionData];

    const currentIndex = temp.findIndex(
      (item) => item.name === selectedSymptomId
    );
    temp[currentIndex] = {
      ...temp[currentIndex],
      detailData: submissionSymptoms,
    };
    setSubmissionData(temp);
  };

  useEffect(() => {
    if (Object.keys(submissionSymptoms).length) {
      handleDetailDataSelection();
    }
  }, [submissionSymptoms]);

  const handleSubChange = useCallback(({ key, value }) => {
    const updateState = (prevState) => {
      const detailItem = Array.isArray(currentDetailData)
        ? currentDetailData?.find(d => d.name === key)
        : { name: key, selection: isMultiSelect(key) ? "Multi Select" : "Single Select" };
  
      if (detailItem.selection === "Multi Select") {
        const prevValues = prevState[key] || [];
        const isValueSelected = prevValues.includes(value);
        
        // Apply restriction if any
        if (detailItem.restriction) {
          const maxAllowed = parseInt(detailItem.restriction.split(' ')[1]);
          
          if (isValueSelected) {
            // If the value is already selected, allow deselection
            return {
              ...prevState,
              [key]: prevValues.filter((val) => val !== value),
            };
          } else {
            // If the value is not selected
            if (prevValues.length < maxAllowed) {
              // If we're under the limit, add the new value
              return {
                ...prevState,
                [key]: [...prevValues, value],
              };
            } else {
              // If we're at the limit, remove the oldest (first) item and add the new one
              return {
                ...prevState,
                [key]: [...prevValues.slice(1), value],
              };
            }
          }
        }
        
        // If there's no restriction, toggle the value
        return {
          ...prevState,
          [key]: isValueSelected
            ? prevValues.filter((val) => val !== value)
            : [...prevValues, value],
        };
      } else {
        // Single select, radio button, dropdown, or text input
        // Special handling for Note
        if (key === "Note") {
          return {
            ...prevState,
            [key]: value.trim() === "" ? [] : [value],
          };
        }
        return {
          ...prevState,
          [key]: [value],
        };
      }
    };
  
    setSubmissionSymptoms(updateState);
    setSelectedOptions(updateState);
  
    forceUpdate({});
  }, [currentDetailData, isMultiSelect]);
  

  

  const isValidSinceInput = (input) => {
    // Allow numbers followed by D, W, M, or Y (case insensitive)
    return /^\d+[dwmy]$/i.test(input);
  };

  const createSearchOptions = (data) => {
    if (data && data.length > 0) {
      let result = [];
      data.map((e) => result.push({ label: e.name, value: e.name }));
      return result;
    } else {
      return [];
    }
  };

  const handleSearch = (value) => {
    handleItemClick({ name: value });
    let _item = initialSymptoms.filter((e) => e.name == value);
    // if (!isSelected(value)) {
    //   dispatch(
    //     ManageDataInPrescription({
    //       context: "Toggle",
    //       item: "symptom",
    //       payload: _item[0],
    //       existing: submissionData?.symptoms,
    //     })
    //   );
    // }

    setSelected(() => _item[0]);
    setOpne(true);
    setSearchValues(createSearchOptions(initialSymptoms));
  };

  const handleRemoveSymptom = (symptom) => {
    const updatedSubmissionData = submissionData.filter((item) => item.name !== symptom.name);
    setSubmissionData(updatedSubmissionData);
    pushToWholeData("symptoms", updatedSubmissionData);
  };

  const handleAddIconClick = (e, data) => {
    setSelectedSymptomId(data.name);
    e.stopPropagation();
    e.preventDefault();
    handleRemoveSymptom(data);
    setOpne(false);
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const isInSearch = (e, data) => {
    for (let i = 0; i < e.length; i++) {
      if (e[i]?.toLowerCase() !== data?.name[i]?.toLowerCase()) {
        return false;
      }
    }
    return true;
  };

  const handleOnSearch = (e) => {
    if (initialSymptoms && initialSymptoms.length > 0 && e) {
      let filterData = initialSymptoms.filter((option) =>
        isInSearch(e, option)
      );
      setSearchValues(createSearchOptions(filterData));
    } else if (!e) {
      setSearchValues(createSearchOptions(initialSymptoms));
    } else setSearchValues([]);
  };

  const pushToWholeData = (key, data) => {
    handleWholeData(key, data);
  };

  const handleSubmissionData = (items) => {
    setSubmissionData(items);
  };

  useEffect(() => {
    if (wholeData.symptoms !== submissionData) {
      handleSubmissionData(wholeData.symptoms);
      if (wholeData.symptoms.length > 0) {
        setSelectedSymptomId(wholeData.symptoms[0].name);
        setOpne(true);
      } else {
        setOpne(false);
      }
    }
  }, [wholeData.symptoms]);

  useEffect(() => {
    if (submissionData.length > 0) {
      pushToWholeData("symptoms", submissionData);
      pushToWholeData("issymptomavailable", true);
    } else if (submissionData.length === 0) {
      //console.debug("submissionData is empty, calling pushToWholeData");
      pushToWholeData("issymptomavailable", false);
    }
  }, [submissionData]);

  useEffect(() => {
    if (wholeData.focus === prescriptionEnums.optionName.SYMPTOMS) {
      ref?.current.scrollIntoView({ behavior: "smooth", block: "start" });
      handleWholeData({ focus: "" });
    }
  }, [wholeData.focus]);

  //console.debug("data.........", data);
  //console.debug("submissionData..........", submissionData);
  //console.debug("detailKeys..........", detailKeys);

  const handleKeyDown = (e) => {
    if (e.key === "%") {
      e.preventDefault();
    }
  };

  console.debug("currentDetailData", currentDetailData);

  const splitTextIntoChunks = (text, chunkSize) => {
    const words = text.split(" ");
    const chunks = [];
    let currentChunk = "";

    for (let i = 0; i < words.length; i++) {
      if ((currentChunk + words[i]).length <= chunkSize) {
        currentChunk += words[i] + " ";
      } else {
        chunks.push(currentChunk.trim());
        currentChunk = words[i] + " ";
      }
    }

    if (currentChunk.trim().length > 0) {
      chunks.push(currentChunk.trim());
    }

    return chunks;
  };

  const renderSplitText = (text) => {
    return splitTextIntoChunks(text, 50).map((chunk, index) => (
      <React.Fragment key={index}>
        {index !== 0 && <br />}
        {chunk}
      </React.Fragment>
    ));
  };


  return (
    <>
      {" "}
      <div className={styles.data_box_wrap} ref={ref}>
        <div className={styles.data_box_container}>
          <div className={styles.header}>
            <div className={styles.searchBox}>
              {/* <input type="text" placeholder='Search' />
                        <img src={AssetStore.managePrescription.search} alt="" /> */}
              {/* <Select
                            suffixIcon={<img src={AssetStore.managePrescription.search} alt="" />}
                            onSelect={handleSearch}
                            getPopupContainer={trigger => trigger.parentNode}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={createSearchOptions()}
                        /> */}

              <Searchbox
                value={selected}
                options={searchValues}
                onSelect={(e) => {
                  handleSearch(e);
                  // e.preventDefault();
                  // e.stopPropagation();
                }}
                onSearch={handleOnSearch}
                placeholder="Search"
              />
            </div>

            <button
              className={styles.add_new_button}
              onClick={() => {
                setAddOpen(true);
              }}
            >
              <span>Add new</span>
              <BlackAdd />
            </button>
          </div>

          <div className={styles.body}>
            <div className={styles.caption}>
              <ClockSmall />
              {name}
            </div>

            <div className={styles.data_list_wrap}>
              <div className={styles.data_list}>
                {submissionData &&
                  submissionData.length > 0 &&
                  submissionData.map((each, key) => {
                    return (
                      <div
                        onClick={() => {
                          handleItemClickSelected(each);
                        }}
                        className={`${styles.data_list_item} ${styles.data_list_item_selected}`}
                        key={key}
                      >
                        <div>{renderSplitText(each?.name)}</div>
                        <div
                          onClick={(e) => {
                            handleAddIconClick(e, each);
                          }}
                          className={`${styles.addIcon} ${styles.addIconNotSelected}`}
                        >
                          <BlueAdd isSelected={false} />
                        </div>
                      </div>
                    );
                  })}
              </div>

              <div className={styles.data_list}>
                {data &&
                  data.length > 0 &&
                  data.slice(0, 10).map((each, key) => {
                    if (!isSelected(each)) {
                      return (
                        <div
                          onClick={() => {
                            handleItemClick(each);
                          }}
                          className={`${styles.data_list_item} ${
                            isSelected(each) && styles.data_list_item_selected
                          }`}
                          key={key}
                        >
                             <div>{renderSplitText(each?.name)}</div>
                          <div
                            onClick={(e) => {
                              handleAddIconClick(e, each);
                            }}
                            className={`${styles.addIcon} ${
                              !isSelected(each)
                                ? styles.addIconSelected
                                : styles.addIconNotSelected
                            }`}
                          >
                            <BlueAdd isSelected={isSelected(each)} />
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>
            </div>
          </div>

          {haveNote ? (
            <div className={styles.footer}>
              <div className={styles.caption}>Note</div>
              <div className={styles.textareaContainer}>
                <Textarea
                  id="noteTextarea"
                  value={noteValue !== undefined ? noteValue : ""}
                  onChange={onChangeNote}
                  className={styles.textarea}
                  style={{ height: textareaHeight }}
                  maxLength={200}
                  onKeyDown={handleKeyDown}
                  onPaste={(e) => {
                    e.preventDefault(); // Prevent default paste behavior
                    const pastedData = e.clipboardData.getData("text/plain");
                    const start = e.target.selectionStart;
                    const end = e.target.selectionEnd;
                    const currentValue = e.target.value;

                    // Calculate the available space
                    const availableSpace =
                      200 - (currentValue.length - (end - start));

                    // Truncate the pasted data if necessary
                    const truncatedPastedData = pastedData.substring(
                      0,
                      availableSpace
                    );

                    const newValue =
                      currentValue.substring(0, start) +
                      truncatedPastedData +
                      currentValue.substring(end);

                    // Use the existing onChangeNote function to update the state
                    onChangeNote({
                      target: {
                        value: newValue.substring(0, 200), // Ensure it doesn't exceed 200 characters
                      },
                    });

                    // Set cursor position after the pasted text
                    setTimeout(() => {
                      e.target.setSelectionRange(
                        start + truncatedPastedData.length,
                        start + truncatedPastedData.length
                      );
                    }, 0);
                  }}
                />
                {(!noteValue || noteValue === "") && (
                  <div className={styles.placeholder}>Enter note here</div>
                )}
              </div>
            </div>
          ) : null}
        </div>
        {selectedSymptomId !== "Routine visit" && (
          <div
            className={`${styles.options_container} ${
              isOpen
                ? styles.options_container_open
                : styles.options_container_close
            }`}
          >
            <div className={styles.option_item}>
              <div className={styles.item_list}>
                <div className={`${styles.item} ${styles.item_title}`}>
                  {selectedSymptomId}
                </div>
              </div>
            </div>

            {detailKeys.map((item, index) => {
              console.log("selectedSymptomId", selectedSymptomId);

              // const detailItem = Array.isArray(currentDetailData)
              //   ? currentDetailData.find(d => d.name === item)
              //   : { name: item, options: currentDetailData[item], selection: isMultiSelect(item) ? "Multi Select" : "Single Select" };
              const detailItem = Array.isArray(currentDetailData)
                ? currentDetailData.find((d) => d.name === item)
                : {
                    name: item,
                    options: currentDetailData[item],
                    selection: isMultiSelect(item)
                      ? "Multi Select"
                      : "Single Select",
                  };

              if (!detailItem) {
                console.warn(`No detail item found for ${item}`);
                return null;
              }

              return (
                <div className={styles.option_item} key={index}>
                  <div className={styles.caption}>
                    {capitalizeFirstLetter(detailItem.name)}
                  </div>

                  {(selectedSymptomId === "Kidney stone" ||
                    selectedSymptomId === "Hematuria" ||
                    selectedSymptomId === "Retention of urine") &&
                    detailItem.name === "Since" && (
                      <>
                        <div className={styles.form_item}>
                          <Textarea
                            value={getSubValue("Since")?.[0] || ""}
                            onChange={(e) => {
                              const value = e.target.value;
                              handleSubChange({ key: "Since", value });
                            }}
                            // onBlur={(e) => {
                            //   const value = e.target.value.toUpperCase();
                            //   if (!isValidSinceInput(value)) {
                            //     // If invalid, you can either clear the input or set it to a default value
                            //     handleSubChange({
                            //       key: "custom_since",
                            //       value: "",
                            //     });
                            //     // Optionally, show an error message to the user
                            //   }
                            // }}
                            className={styles.form_item_input}
                            type="text"
                            placeholder="Enter custom since"
                            maxLength={10}
                          />
                        </div>
                        {/* <div className={styles.item_list}>
      {detailItem.options?.map((each, key) => (
        <div
          key={key}
          onClick={() => handleSubChange({ key: "Since", value: each })}
          className={`${styles.item} ${isSubSelected("Since", each) ? styles.sub_item_selected : ''} ${styles.single_select}`}
        >
          {each}
        </div>
      ))}
    </div> */}
                      </>
                    )}
                  {detailItem.selection === "Single Select" && (
                    <div className={styles.item_list}>
                      {detailItem.options?.map((each, key) => (
                        <div
                          key={key}
                          onClick={() =>
                            handleSubChange({
                              key: detailItem.name,
                              value: each,
                            })
                          }
                          className={`${styles.item} ${
                            isSubSelected(detailItem.name, each)
                              ? styles.sub_item_selected
                              : ""
                          } ${styles.single_select}`}
                        >
                          {each}
                        </div>
                      ))}
                    </div>
                  )}
                  {detailItem.selection === "Multi Select" && (
                    <div className={styles.item_list}>
                      {detailItem.options?.map((each, key) => (
                        <div
                          key={`${item}-${each}-${isSubSelected(item, each)}`}
                          // key={key}
                          onClick={() =>
                            handleSubChange({
                              key: detailItem.name,
                              value: each,
                            })
                          }
                          className={`${styles.item} ${
                            isSubSelected(detailItem.name, each)
                              ? styles.sub_item_selected
                              : ""
                          } ${styles.multi_select}`}
                        >
                          {each}
                        </div>
                      ))}
                    </div>
                  )}
                  {detailItem.selection === "Radio Button" && (
                    <Radio.Group
                      value={getSubValue(detailItem.name)?.[0]}
                      onChange={(e) =>
                        handleSubChange({
                          key: detailItem.name,
                          value: e.target.value,
                        })
                      }
                    >
                      {detailItem.options?.map((each, key) => (
                        <Radio key={key} value={each}>
                          {each}
                        </Radio>
                      ))}
                    </Radio.Group>
                  )}
                  {detailItem.selection === "Drop Down" && (
                    <Select
                      options={detailItem.options.map((opt) => ({
                        value: opt,
                        label: opt,
                      }))}
                      value={getSubValue(detailItem.name)?.[0]}
                      onChange={(value) =>
                        handleSubChange({ key: detailItem.name, value })
                      }
                      className={styles.form_item_input}
                      style={{ width: "100%", maxWidth: "700px" }}
                      placeholder="Select"
                    />
                  )}
                  {detailItem.selection === "Text Box" && (
                    <Textarea
                      value={getSubValue(detailItem.name)?.[0] || ""}
                      onChange={(e) =>
                        handleSubChange({
                          key: detailItem.name,
                          value: e.target.value,
                        })
                      }
                      className={styles.form_item_input}
                      style={{ height: textareaHeight }}
                      placeholder="Type here"
                      maxLength={200}
                      onKeyDown={handleKeyDown}
                      onPaste={(e) => {
                        e.preventDefault(); // Prevent default paste behavior
                        const pastedData =
                          e.clipboardData.getData("text/plain");
                        const start = e.target.selectionStart;
                        const end = e.target.selectionEnd;
                        const currentValue = e.target.value;

                        // Calculate the available space
                        const availableSpace =
                          200 - (currentValue.length - (end - start));

                        // Truncate the pasted data if necessary
                        const truncatedPastedData = pastedData.substring(
                          0,
                          availableSpace
                        );

                        const newValue =
                          currentValue.substring(0, start) +
                          truncatedPastedData +
                          currentValue.substring(end);

                        // Use the existing handleSubChange function to update the state
                        handleSubChange({
                          key: detailItem.name,
                          value: newValue.substring(0, 200), // Ensure it doesn't exceed 200 characters
                        });

                        // Set cursor position after the pasted text
                        setTimeout(() => {
                          e.target.setSelectionRange(
                            start + truncatedPastedData.length,
                            start + truncatedPastedData.length
                          );
                        }, 0);
                      }}
                    />
                  )}
                </div>
              );
            })}

            {/* <div className={styles.option_item}>
              <div className={styles.caption}>Note</div>

              <div className={styles.form_item}>
                <Textarea
                  key={selected}
                  value={getSubValue("note") ?? ""}
                  onChange={(e) => {
                    handleSubChange({ key: "note", value: e.target.value });
                  }}
                  className={styles.form_item_input}
                  id="noteTextarea"
                  // className={styles.textarea}
                  style={{ height: textareaHeight }}
                  placeholder="Type here"
                  maxLength={200}
                  onKeyDown={handleKeyDown}
                />
              </div>
            </div> */}
          </div>
        )}
      </div>
      <AddDataModal
        onSubmit={(e) => {
          handleAddData(e);
        }}
        title={addTitle ? addTitle : "Add new"}
        showModal={isAddOpen}
        hidemodal={() => {
          setAddOpen(false);
        }}
      />
    </>
  );
}

export default RecentSymptoms;
